module.exports = __webpack_public_path__ + "static/directory_1@2x-b359b010ba14ede82cd1c3b639fb2f9a.png";